// ==================== ADMIN PLANS SERVICE ====================

import { apiService } from './api';
import type { ApiResponse, SubscriptionPlan } from '../types';

// ==================== TYPES ====================

export interface CreatePlanDto {
  name: 'STARTER' | 'STANDARD' | 'PROFESSIONAL' | 'ENTERPRISE';
  description?: string;
  monthlyPrice: number;
  yearlyPrice?: number;
  currency?: string;
  maxContacts: number;
  maxMessagesPerMonth: number;
  maxCampaigns: number;
  maxTemplates: number;
  features?: string[];
  isActive?: boolean;
  isPopular?: boolean;
  sortOrder?: number;
}

export interface UpdatePlanDto {
  name?: 'STARTER' | 'STANDARD' | 'PROFESSIONAL' | 'ENTERPRISE';
  description?: string;
  monthlyPrice?: number;
  yearlyPrice?: number;
  currency?: string;
  maxContacts?: number;
  maxMessagesPerMonth?: number;
  maxCampaigns?: number;
  maxTemplates?: number;
  features?: string[];
  isActive?: boolean;
  isPopular?: boolean;
  sortOrder?: number;
}

export interface PlanWithCount extends SubscriptionPlan {
  createdAt?: string;
  updatedAt?: string;
  _count?: {
    subscriptions: number;
  };
}

// ==================== SERVICE ====================

export const adminPlansService = {
  /**
   * Get all subscription plans (including inactive)
   */
  getAll: async (includeInactive = true): Promise<ApiResponse<PlanWithCount[]>> => {
    return apiService.get<PlanWithCount[]>(`/admin/subscription-plans?includeInactive=${includeInactive}`);
  },

  /**
   * Get plan by ID
   */
  getById: async (id: string): Promise<ApiResponse<PlanWithCount>> => {
    return apiService.get<PlanWithCount>(`/admin/subscription-plans/${id}`);
  },

  /**
   * Create a new plan
   */
  create: async (data: CreatePlanDto): Promise<ApiResponse<SubscriptionPlan>> => {
    return apiService.post<SubscriptionPlan>('/admin/subscription-plans', data);
  },

  /**
   * Update a plan
   */
  update: async (id: string, data: UpdatePlanDto): Promise<ApiResponse<SubscriptionPlan>> => {
    return apiService.patch<SubscriptionPlan>(`/admin/subscription-plans/${id}`, data);
  },

  /**
   * Delete a plan
   */
  delete: async (id: string): Promise<ApiResponse<{ deleted: boolean }>> => {
    return apiService.delete<{ deleted: boolean }>(`/admin/subscription-plans/${id}`);
  },

  /**
   * Toggle plan active status
   */
  toggleActive: async (id: string): Promise<ApiResponse<SubscriptionPlan>> => {
    return apiService.patch<SubscriptionPlan>(`/admin/subscription-plans/${id}/toggle-active`);
  },
};

export default adminPlansService;

